import React from 'react';
import nebulaTheme from '@nebula/theme';
import { Modal } from '@nebula/modal';
import { ThemeProvider } from 'styled-components';
import GlobalStyles, { BodyLarge400 } from '@nebula/global-styles';
import PropTypes from 'prop-types';

const CancelBillingDateChangeDialog = ({ isShowing, toggleHide, onYes }) => (
  <ThemeProvider theme={nebulaTheme}>
    <GlobalStyles />
    <Modal
      showDefaultCloseBtn={false}
      zIndex={10}
      header="Cancel the change?"
      isShowing={isShowing}
      toggleHide={toggleHide}
      actions={[
        {
          label: 'Yes, cancel change',
          onClick: () => {
            toggleHide();
            onYes();
          },
          buttonKind: 'secondaryMagenta',
        },
        {
          label: 'No, continue',
          onClick: toggleHide,
          buttonKind: 'secondaryMagenta',
        },
      ]}
    >
      <BodyLarge400>You&apos;ll keep your current billing date.</BodyLarge400>
    </Modal>
  </ThemeProvider>
);

CancelBillingDateChangeDialog.defaultProps = {
  onYes: () => window.history.back(),
};

CancelBillingDateChangeDialog.propTypes = {
  isShowing: PropTypes.bool.isRequired,
  toggleHide: PropTypes.func.isRequired,
  onYes: PropTypes.func,
};

export default CancelBillingDateChangeDialog;
